<app-individual-data (data)="data1($event)" [insideForm]="backTrue" (states)="captureState($event)"
  *ngIf="step1"></app-individual-data>

<app-verify-code [details]="dataStep1" (states)="captureVerifycode($event)" (moveToStep1)="moveFromTo($event)"
  *ngIf="step2"></app-verify-code>

<app-success-screen (states)="captureSuccess($event)" *ngIf="step3"></app-success-screen>

<app-basic-information (basicDetails)="data2($event)" [biodata]="biodata" (states)="captureCamera($event)"
  *ngIf="step4"></app-basic-information>

<app-capture-image (goBack)="goBack(5)" [ninDetails]="dataStep1?.ninDetails" (imageCaptured)="goToPreview($event)"
  *ngIf="step5"></app-capture-image>

<app-individual-preview (onSubmit)="submit()" [previewDetails]="previewDetails" [isSubmitting]="isSubmitting"
  *ngIf="step6" (goBack)="goBack(6)"></app-individual-preview>
